import TableChain from './TableChain';

export default TableChain;
